/**
 * Organisation Video Mapping
 *
 * Maps organisation IDs to their YouTube video IDs
 * Add new organisations as needed: organisationId: 'YouTubeVideoId'
 */

const ORGANISATION_VIDEOS = {
  7: "H3pIeuX6AkE",
  // Add more organisations below:
  // 3: 'VIDEO_ID_HERE',
  // 4: 'VIDEO_ID_HERE',
};

/**
 * Get YouTube video ID for an organisation
 * @param {number|string} organisationId - The organisation ID
 * @returns {string|null} YouTube video ID or null if not found
 */
export const getOrganisationVideoId = (organisationId) => {
  const id = parseInt(organisationId, 10);
  return ORGANISATION_VIDEOS[id] || null;
};

export default ORGANISATION_VIDEOS;
